import { mapFirstLink } from '../DataTypes/linkMapper';
import logger from '3-foundation/Logging/logger';

export const mapBlurbCard = ({ content, settings }): Content.ContentModule => {
	try {
		return {
			documentType: content?.contentType,
			content: {
				properties: {
					kicker: content?.properties?.kicker ?? null,
					heading: content?.properties?.heading ?? null,
					text: content?.properties?.text?.markup ?? null,
					link: mapFirstLink(content?.properties?.link),
				},
			},
			settings: {
				properties: {
					displayLinkAsButton: settings?.properties?.displayLinkAsButton ?? null,
				},
			},
		};
	} catch (e) {
		logger.error(`Could not map BlurbCard \nCause: ${e}`);
		throw new Error(`Could not map BlurbCard \nCause: ${e}`, e);
	}
};
